// 服务端算路
import service from '@/utils/axios-v2'

export function calculateServerRouting(data, cancelToken) {
  return service({
    baseURL: process.env.VUE_APP_TP_URL || process.env.VUE_APP_URL,
    url: '/tp/route/planning/v2',
    method: 'post',
    data: data,
    headers: {
      'disable-token': true,
      'installation-id': process.env.VUE_APP_INSTALLATION_ID,
      'client': process.env.VUE_APP_CLIENT
    },
    cancelToken,
    isNotPrompt: true
  })
}
